"use client";

import { cn } from "../../lib/utils";
import { SPINNER_STYLES } from "./constants";
import type { SpinnerProps, SpinnerContainerProps } from "./types";

export const Spinner = ({ size = 24, className, ...props }: SpinnerProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn(SPINNER_STYLES.spinner, className)}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  );
};

export const SpinnerContainer = ({
  children,
  className,
  loading = true,
}: SpinnerContainerProps) => {
  if (!loading) return <>{children}</>;

  return (
    <div className={cn(SPINNER_STYLES.container, className)}>
      <Spinner size={32} />
    </div>
  );
};
